import React, { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';

import Icon from 'components/Icon';
import Button from 'components/Button';
import Portal from 'components/Portal';

import { Menu, Nav, NavHolder, Close, OpenButton } from './style';

const MainMenu = () => {
	const show = useRef(false);
	const ref = useRef();

	const toggle = useCallback(() => {
		if (show.current) {
			ref.current.classList.remove('show');
		} else {
			ref.current.classList.add('show');
		}
		show.current = !show.current;
	}, []);

	const NavList = (
		<Nav>
			<Link
				to={{ pathname: '/', hash: 'about' }}
				className='link'
				onClick={toggle}
			>
				درباره ما
			</Link>
			<Link
				to={{ pathname: '/', hash: 'features' }}
				className='link'
				onClick={toggle}
			>
				ویژگی‌ها
			</Link>
			<Link
				to={{ pathname: '/', hash: 'clients' }}
				className='link'
				onClick={toggle}
			>
				مشتریان
			</Link>
			<Link
				to={{ pathname: '/', hash: 'register' }}
				className='link'
				onClick={toggle}
			>
				ثبت شرکت
			</Link>
			<Link
				to={{ pathname: '/', hash: 'contact' }}
				className='link'
				onClick={toggle}
			>
				تماس با ما
			</Link>
			<Button outline size='sm' to='/menu'>
				سفارش غذا
			</Button>
		</Nav>
	);

	return (
		<>
			<NavHolder>{NavList}</NavHolder>

			<OpenButton onClick={toggle}>
				<Icon name='menu' />
			</OpenButton>

			<Portal>
				<Menu ref={ref}>
					<div
						className='lightbox'
						onClick={toggle}
						onKeyPress={toggle}
						role='button'
						tabIndex='0'
					/>

					<div className='inner'>
						<Close onClick={toggle}>
							<Icon name='cross' />
						</Close>

						{NavList}
					</div>
				</Menu>
			</Portal>
		</>
	);
};

export default MainMenu;
